module.exports = __webpack_public_path__ + "img/i1.a0b97019.svg";